import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import { ContentBox } from "ui-library/layouts";
import { Typography } from "ui-library/atoms";

import i18n from "core/i18n";
import pageContext from "core/pageContext";
import user from "core/user";
import { Field } from "core/hookForm";
import { useGetFieldDirection } from "core/hooks";
import { FundsTransferType } from "types";

import { VehicleCancellationFormValues } from "../../types";

import { AccountSectionCs } from "./AccountSectionCs";
import { AccountSectionSk } from "./AccountSectionSk";

export const AccountSection: FC = ({}) => {
    const { t } = i18n.useTranslation();
    const { watch } = useFormContext<VehicleCancellationFormValues>();
    const isSkSite = useSelector(pageContext.getIsSlovakSite);

    const selectedFundsTransferType = watch("fundsTransfer");

    const isOneTimeChangeRole = useSelector(user.getIsOneTimeChangeRole);

    const fundTransferOptions = [
        {
            code: FundsTransferType.INSURANCE_PAYMENT_BANK_ACCOUNT,
            value: t("change.fundsTransfer.type.insurancePaymentBankAccount"),
        },
        {
            code: FundsTransferType.OTHER_BANK_ACCOUNT,
            value: t("change.fundsTransfer.type.OtherBankAccount"),
        },
    ];

    return (
        <>
            <ContentBox>
                <Typography variant="h4" markDown={t("vehicle.change.contractCancellation.fundsTransfer")} />
            </ContentBox>

            {isOneTimeChangeRole && (
                <>
                    <ContentBox>
                        <Typography markDown={t("change.fundsTransfer.infoText")} />
                    </ContentBox>

                    <ContentBox fullWidth>
                        <Field<VehicleCancellationFormValues>
                            name="fundsTransfer"
                            input="radioGroup"
                            direction={useGetFieldDirection()}
                            options={fundTransferOptions}
                        />
                    </ContentBox>
                </>
            )}

            {selectedFundsTransferType === FundsTransferType.OTHER_BANK_ACCOUNT && (
                <>
                    {isSkSite && <AccountSectionSk sectionName="fundsTransferBankAccount" />}
                    {!isSkSite && <AccountSectionCs sectionName="fundsTransferBankAccount" />}
                </>
            )}
        </>
    );
};
